//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getContentByCode} from "@/utils/utils";

export default {
  data() {
    return {

    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    }
  },
  methods: {
    getText(code) {
      if (this.getTextBlocks.data && this.getTextBlocks.data.data) {
        return getContentByCode(this.getTextBlocks.data.data, code)
      }
      return '';
    },
    openFeedback() {
      this.$store.commit('sidebars/feedbackAsideOpen')
    },
    openErrorForm() {
      if (window && window.b24form && window.b24form.forms) {
        window.b24form.forms = null
      }
      this.$store.commit('forms/openErrorForm')
    },
    goToUrl (item, e) {
      if (item.action) {
        switch(item.action) {
          case 'openFeedback':
            e.stopPropagation()
            this.openFeedback()
            break
          case 'openErrorForm':
            e.stopPropagation()
            this.openErrorForm()
            break
          default:
            return null
            break
        }
      }
      if (item.link) {
        if(item.link.includes('http')) {
          window.open(item.link, '_blank')
        } else {
          this.$router.push(item.link)
        }
      }
    },
  },
  chimera: {
    getTextBlocks() {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'footer-bottom-text',
        auto: true,
        params: {
          code: ['footer-bottom-text'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getFooter1() {
      return {
        url: '/api/menu/',
        key: 'footer1',
        params: {
          code: 'footer1',
          lang: this.$i18n.locale || 'en'
        }
      }
    },
    getFooter2() {
      return {
        url: '/api/menu/',
        key: 'footer2',
        params: {
          code: 'footer2',
          lang: this.$i18n.locale || 'en'
        }
      }
    }
  }
}
